import { TitleCell, TitleRow } from '../../../../components/ReusableComponents/Table'

const SummaryTitleRow = () => (
  <TitleRow style={{ position: 'sticky', top: 70 }}>
    <TitleCell>Id</TitleCell>
    <TitleCell>Hotel name</TitleCell>
    <TitleCell>CSM</TitleCell>
    <TitleCell>PMS</TitleCell>
    <TitleCell textAlign="center">Autopay</TitleCell>
    <TitleCell textAlign="center">3 Mo</TitleCell>
    <TitleCell textAlign="center">6 Mo</TitleCell>
    <TitleCell textAlign="center">9 Mo</TitleCell>
    <TitleCell textAlign="center">12 Mo</TitleCell>
    <TitleCell textAlign="center">15 Mo</TitleCell>
    <TitleCell textAlign="center">15 Mo+</TitleCell>
    <TitleCell textAlign="center">Sales</TitleCell>
    <TitleCell textAlign="center">Drip</TitleCell>
    <TitleCell textAlign="center">Service</TitleCell>
    <TitleCell textAlign="center">
      After
      <br /> visit
    </TitleCell>
    <TitleCell textAlign="center">Text</TitleCell>
    <TitleCell textAlign="center">Converted</TitleCell>
    <TitleCell textAlign="center">
      Late <br /> balance
    </TitleCell>
    <TitleCell textAlign="center">
      Outstanding <br /> Invoices
    </TitleCell>
    <TitleCell>Notes</TitleCell>
  </TitleRow>
)

export default SummaryTitleRow
